<template>
  <ColumnChart
    :hcTitle="apiData ? apiData.title : null"
    :hcSubtitle="apiData ? apiData.last_update : null"
    :hcData="apiData ? apiData.chart_data.values : []"
    :xAxisCategories="apiData ? apiData.chart_data.categories : []"
  />
</template>

<script>
// import StackedChart from "@/components/charts/highcharts/StackedColumnChart.vue";
import ColumnChart from "@/components/charts/highcharts/VBarChart.vue";
import RedElectricaAPI from "@/api/red-electrica.js";

export default {
  //   props: ["apiData"],
  components: { ColumnChart }, // StackedChart
  data() {
    return {
      apiData: null,
      apiResponse: null,
      queryParams: {
        lang: "en",
        category: "mercados",
        widget: "componentes-precio",
        start_date: "2021-02-01",
        end_date: new Date().toISOString().slice(0, 10),
        time_trunc: "month",
        geo_trunc: null,
        geo_limit: null,
        geo_ids: null,
        data_format: "column",
      },
    };
  },
  methods: {
    getApiData() {
      RedElectricaAPI.get(this.queryParams)
        .then((response) => {
          this.apiData = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {},
  mounted() {
    this.getApiData();
  },
};
</script>

<style scoped>
.chart-container {
  width: 80%;
  height: 80%;
}
</style>
